import { Component, OnInit } from '@angular/core';
import { OrgService } from '../_services/org.service';

import { Subscription } from 'rxjs';
@Component({
	selector: 'dropdown-district',
	templateUrl: './dropdown-district.component.html',
})
export class DropdownDistrictComponent implements OnInit {
	districts: any[];
	selectedDistrict: any;
	subscriptions: Subscription[] = [];
	constructor(public orgService: OrgService) {}

	ngOnInit(): void {
		this.subscriptions.push(
			this.orgService.districts$.subscribe((data: any) => {
				this.districts = data;
			}),
		);

		this.subscriptions.push(
			this.orgService.selectedDistrict$.subscribe((data: any) => {
				this.selectedDistrict = data;
			}),
		);
	}
	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
